var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 131,
    viewBox: "0 0 252 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48678 4.55044C0.630975 3.46693 0.815562 1.89482 1.89906 1.03902C2.98256 0.183223 4.55467 0.36781 5.41047 1.45131L1.48678 4.55044ZM251.391 111.427C252.294 112.471 252.18 114.05 251.136 114.953L234.117 129.671C233.073 130.574 231.494 130.46 230.591 129.415C229.688 128.371 229.802 126.792 230.846 125.889L245.974 112.806L232.891 97.6787C231.988 96.6343 232.103 95.0556 233.147 94.1524C234.191 93.2493 235.77 93.3637 236.673 94.4081L251.391 111.427ZM5.41047 1.45131C17.6358 16.9294 47.573 41.98 90.1481 64.3045C132.665 86.5985 187.588 106.067 249.681 110.569L249.32 115.555C186.413 110.995 130.827 91.2801 87.8262 68.7327C44.8839 46.2157 14.2952 20.7667 1.48678 4.55044L5.41047 1.45131Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomarrow);
export default __webpack_public_path__ + "static/media/bottomarrow.66ba56307ca9594a660f8414845ebc0e.svg";
export { ForwardRef as ReactComponent };